<template>
    <div class="actionCodeInput">
        <p class="text-bold" v-html="translation.WSM_EnterYourDiscountCode">Enter action code</p>
        
        <label>
            <input :placeholder="translation.wsm_DiscountCode" type="text" maxlength="" v-model="actionCodeInput" @input="handleInputChange(actionCodeInput)" @keyup.enter="actionCodeConfirm(actionCodeInput)">
            <button class="actionCodeBtn" @click="actionCodeConfirm(actionCodeInput)" v-html="translation.wsm_Apply">Apply</button>
        </label>
        
        <div class="expander" :class="(responseObj != null && Object.keys(responseObj).length != 0)?'expanded':''">
            <div style="overflow:hidden;">
                <Transition name="fade">
                    <div v-if="responseObj && Object.keys(responseObj).length">
                        <p key="error" v-if="responseObj && responseObj.errorMessage != ''" v-html="responseObj && responseObj.errorMessage">Error</p>
                        <p key="success" v-html="responseObj && responseObj.message">Succes</p>
                    </div>      
                </Transition>
            </div>
        </div>

    </div>
</template>

<script>
export default{
    name: 'actionCodeInput',
    data(){
        return{
            webMessage: ['WSM_EnterYourDiscountCode','wsm_Apply', 'wsm_Cancel', 'wsm_DiscountCode'],
            translation: [],
            actionCodeInput: "",
            responseObj: null,
        }
    },
    mounted(){
        this.translation = cws(this.webMessage);
    },
    methods: {
        actionCodeConfirm(input){    

            const parameter = {"actionCode":input}
            axios.get(`${window.basedir}/ajaxRequestServlet?mode=ActionCodeConfirm&payload=${encodeURI(JSON.stringify(parameter))}`)
            .then((response) =>{
                this.responseObj = response.data;
                if(this.responseObj.status == 200){
                    this.$store.dispatch("getPriceList", [this.$root.settings.showCat,this.$root.settings.hideCat]);
                }
            })
            .catch((error)=>{
                console.error(error)
            })
        },
        handleInputChange: function (input){
            this.responseObj = {}

        },

    },
    
}
</script>

<style scoped lang="scss">
.text-bold{
    font-weight: bold;
}
.actionCodeInput{
    
    margin-bottom: 10px;
    background: #f5f2e8;
    padding: 10px;
    border: 1px solid #e3ddc7;
    border-radius: 4px;
*{
    margin: 0;
    margin-bottom: 0;
    box-sizing: border-box;
    input{
        width: unset;
        min-width: unset;
        max-width: unset;
    }
}


button{
    background: #7caf63;
    border: 1px solid #7caf63;
    color: white;
    padding: 5px 15px;
    border-radius: 3px;
    cursor: pointer;
    &:hover{
        background: #759e5c;
        border-color: #759e5c;
    }
}
input{
    padding: 10px;
    width:100%;
}

label{
    display:flex;
    gap: 10px;
    margin: 5px 0px;
    width:100%;
}
@media screen and (max-width: 1000px){
    label{
        flex-direction: column;
    }
}

.expander{
    display: grid;
    grid-template-rows: 0fr;
    transition: all .2s ease;
}
.expanded{
    grid-template-rows: 1fr;
}
}
.fade-enter-active, .fade-leave-active{
    transition: opacity .3s;
    transition-delay: 0.1s;
}
.fade-enter, .fade-leave-to{
    opacity: 0;
}
</style>